import { Button } from '@lokalise/louis'
import type { ComponentProps, PropsWithChildren } from 'react'

import styles from './BannerComponents.module.css'

export const BannerContainer = ({ children }: PropsWithChildren) => (
  <div className={styles.container} data-testid="upsell-banner">
    {children}
  </div>
)

export const BannerTextContainer = ({ children }: PropsWithChildren) => (
  <div className={styles.textContainer}>{children}</div>
)

export const BannerHeader = ({ children }: PropsWithChildren) => (
  <h3 className={styles.header}>{children}</h3>
)

export const BannerSubHeader = ({ children }: PropsWithChildren) => (
  <div className={styles.subHeader}>{children}</div>
)

export const BannerSubHeaderBlue = ({ children }: PropsWithChildren) => (
  <div className={styles.subHeader_blue}>{children}</div>
)

export const BannerTextBody = ({ children }: PropsWithChildren) => (
  <p className={styles.body}>{children}</p>
)

export const BannerCTAContainer = ({ children }: PropsWithChildren) => (
  <div className={styles.ctaContainer}>{children}</div>
)

export const BannerCTASubText = ({ children }: PropsWithChildren) => (
  <p className={styles.ctaSubText}>{children}</p>
)

export const BannerSecondaryButton = ({
  children,
  ...props
}: PropsWithChildren<ComponentProps<typeof Button>>) => (
  <Button {...props} className={styles.secondaryButton} variant="secondary">
    {children}
  </Button>
)

/**
 * Hides children if BannerContainer shrinks below a certain size
 */
export const BannerHideIfContainerTooSmall = ({ children }: PropsWithChildren) => (
  <div className={styles.hideableContainer}>{children}</div>
)
